import React from "react";
import standardizeEmail from "../../common/standardizeEmail";
import * as Auth from "../../domains/AuthDomain";

const EMAIL_CONSENT_PROMPT =
  "Yes, I would like to receive emails from my coaches for workout tips, new programs, updates and offers.";

class RedeemVoucher extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isAuthed: false,
      userId: "",
      email: "",
      password: "",
      firstName: "",
      lastName: "",
      emailConsent: false,
      showSignup: false,
      showLogin: false,
      activeSection: 0, //values are 0-1
      validationErrors: {},
      emailError: false,
      pwError: false,
      loginErrorDesc: "",
      loginError: false,
      authLoading: false,
      redeemError: "",
      agreementsChecked: true,
      voucherId: "",
      redeemLoading: false,
    };
  }

  goToForgotPassword = () => {
    const forgotURL = `/forgotpassword`;
    this.props.history.push({
      pathname: forgotURL,
      state: { allowBack: true },
    });
  };

  onClickAgreementsCheck = () => {
    this.setState({
      agreementsChecked: !this.state.agreementsChecked,
    });
  };

  calculateActiveSection = () => {
    if (!this.state.isAuthed) {
      this.setState({ activeSection: 0 });
    } else {
      this.setState({ activeSection: 1 });
    }
  };

  renderErrors = () => {
    const emailErrorText = `Invalid email address`;
    const pwErrorText = `Password must be at least 6 characters long`;
    const loginErrorText = `` + this.state.loginErrorDesc;

    return (
      <div className="login-errors">
        <div className="error-text">
          {" "}
          {this.state.emailError ? emailErrorText : null}{" "}
        </div>
        <div className="error-text">
          {" "}
          {this.state.pwError ? pwErrorText : null}{" "}
        </div>
        <div className="error-text">
          {" "}
          {this.state.loginError ? loginErrorText : null}{" "}
        </div>
      </div>
    );
  };

  onClickLogin = async () => {
    this.setState({ authLoading: true });

    const { password } = this.state;
    let { email } = this.state;

    email = standardizeEmail(email);

    const { accessToken, error, error_description } = await Auth.getAccessToken(
      { email, password }
    );

    if (accessToken) {
      const { userId } = await Auth.getUserInfo(accessToken);

      this.setState(
        {
          isAuthed: true,
          loginError: false,
          userId,
          authLoading: false,
        },
        () => {
          this.calculateActiveSection();
        }
      );

      await Auth.dbAuth(userId);

    } else if (error) {
      this.setState({
        loginErrorDesc: error_description,
        loginError: true,
        authLoading: false,
      });
    }
  };

  onClickSignup = async () => {
    const {
      password,
      firstName,
      lastName,
      emailConsent,
    } = this.state;
    let { email } = this.state;

    email = standardizeEmail(email);

    this.setState({
      loginErrorDesc: "", //Wipes out prior login attempt error message as validation may stop Auth.signup from running
      authLoading: true,
    });

    const emailValid = Auth.checkEmailValid(email);
    this.setState({ emailError: !emailValid });

    const pwValid = Auth.checkPwValid(password);
    this.setState({ pwError: !pwValid });

    if (!emailValid || !pwValid) {
      this.setState({
        authLoading: false,
      });

      return;
    }

    const { userId, error } = await Auth.signup({
      email,
      password,
      firstName,
      lastName,
    });

    if (error) {
      this.setState({
        loginErrorDesc: error,
        loginError: true,
        authLoading: false,
      });
    } else if (userId) {
      const auth = await Auth.dbAuth(userId);

      if (!auth) {
        console.log("Auth failed");
        return;
      }

      await this.props.actions.signUpActions.initUserAcct({
        userId,
        email,
        firstname: firstName,
        lastname: lastName,
        coachOrgId: null,
        emailConsent: emailConsent,
        emailConsentPrompt: EMAIL_CONSENT_PROMPT,
        waiverConsent: true,
      });

      this.setState(
        {
          isAuthed: true,
          loginError: false,
          userId,
          authLoading: false,
        },
        () => {
          this.calculateActiveSection();
        }
      );
    }
  };

  renderSeparator = () => {
    return (
      <div className="separator-container">
        <div className="half-horiz-line" />
        <div className="or-text">OR</div>
        <div className="half-horiz-line" />
      </div>
    );
  };

  renderLogin = () => {
    if (this.state.showLogin) {
      const loader = <div className="loader" />;

      return [
        <div className="login-form">
          <input
            type="text"
            className="account-input"
            placeholder="E-mail"
            id="login-email"
            maxLength="254"
            onChange={(event) => {
              this.setState({ email: event.target.value });
            }}
            value={this.state.email}
          />
          <input
            type="password"
            className="account-input"
            placeholder="Password"
            id="login-pw"
            maxLength="128"
            onChange={(event) => {
              this.setState({ password: event.target.value });
            }}
            onKeyPress={(e) => {
              if (e.which === 13) {
                this.onClickLogin();
              }
            }} //Allows enter key to submit
            value={this.state.password}
          />
          <button
            type="button"
            className="finish-login-button"
            onClick={() => {
              this.onClickLogin();
            }}
          >
            {this.state.authLoading ? loader : "Login"}
          </button>
          <div
            className="forgot-password-text"
            onClick={this.goToForgotPassword}
          >
            Forgot password?
          </div>
        </div>,
      ];
    } else {
      return (
        <button
          type="button"
          className="login-button"
          onClick={() => {
            this.setState({
              showLogin: true,
              showSignup: false,
              password: "",
              loginError: false,
              pwError: false,
              emailError: false,
              loginErrorDesc: "",
            });
          }}
        >
          Log in
        </button>
      );
    }
  };

  renderSignup = () => {
    if (this.state.showSignup) {
      const loader = <div className="loader" />;
      const waiverUrl = `https://trybe.do/waiver`;

      return (
        <div className="signup-form">
          <input
            type="text"
            className="account-input"
            placeholder="First name"
            id="firstName"
            maxLength="50"
            onChange={(event) => {
              this.setState({ firstName: event.target.value });
            }}
            value={this.state.firstName}
          />
          <input
            type="text"
            className="account-input"
            placeholder="Last name"
            id="lastName"
            maxLength="50"
            onChange={(event) => {
              this.setState({ lastName: event.target.value });
            }}
            value={this.state.lastName}
          />
          <input
            type="text"
            className="account-input"
            placeholder="E-mail"
            id="email"
            maxLength="254" //Recommended max length for emails
            onChange={(event) => {
              this.setState({ email: event.target.value });
            }}
            value={this.state.email}
          />
          <input
            type="password"
            className="account-input"
            placeholder="Password"
            id="pw"
            maxLength="128" //Recommended max length for password
            onChange={(event) => {
              this.setState({ password: event.target.value });
            }}
            onKeyPress={(e) => {
              if (e.which === 13) {
                this.onClickSignup();
              }
            }} //Allows enter key submit
            value={this.state.password}
          />

          {this.state.agreementsChecked ? (
            <button
              type="button"
              className="finish-signup-button"
              onClick={this.onClickSignup}
            >
              {this.state.authLoading ? loader : "Create account"}
            </button>
          ) : (
            <div className="finish-signup-button button-disabled">
              {this.state.authLoading ? loader : "Create account"}
            </div>
          )}

          <div className="policies-and-terms">
            <div
              className={
                this.state.agreementsChecked
                  ? "checkbox checkbox-agreed"
                  : "checkbox"
              }
              onClick={this.onClickAgreementsCheck}
            >
              {this.state.agreementsChecked ? (
                <img
                  src={require("../../images/checkmarkWhite.png")}
                  className="checkmark"
                />
              ) : null}
            </div>
            I agree to the&nbsp;
            <a
              href="https://www.iubenda.com/privacy-policy/7826759"
              target="_blank"
            >
              privacy policy
            </a>
            ,&nbsp;
            <a href="https://trybe.do/terms" target="_blank">
              terms of use
            </a>
            ,&nbsp;and&nbsp;
            <a href={waiverUrl} target="_blank">
              waiver
            </a>
            .
          </div>
          <div>{this.state.errors}</div>
        </div>
      );
    } else {
      return (
        <button
          type="button"
          className="signup-button"
          onClick={() => {
            this.setState({
              showSignup: true,
              showLogin: false,
              password: "",
              loginError: false,
              pwError: false,
              emailError: false,
              loginErrorDesc: "",
            });
          }}
        >
          Sign up
        </button>
      );
    }
  };

  renderAccountSection = () => {
    if (this.state.isAuthed) {
      return (
        <div className="logged-in-email">
          <div>Logged in as:</div>
          <div className="email">
            {this.state.email}
            &nbsp;
          </div>
          <button
            type="button"
            className="change-login"
            onClick={() => {
              this.setState(
                { isAuthed: false, showSignup: false, showLogin: false },
                () => {
                  this.calculateActiveSection();
                }
              );
            }}
          >
            Switch Account
          </button>
        </div>
      );
    } else {
      return [
        <div className="account-subcontainer">{this.renderSignup()}</div>,
        <div className="separator-width">{this.renderSeparator()}</div>,
        <div className="account-subcontainer">{this.renderLogin()}</div>,
      ];
    }
  };

  renderVoucherInput = () => {
    return (
      <input
        type="text"
        className="voucher-input"
        placeholder="Enter Voucher Code"
        id="voucherId"
        maxLength="50"
        onChange={(event) => {
          const validString = this.removeInvalidCharacters(event.target.value)
          this.setState({ voucherId: validString});
        }}
        value={this.state.voucherId}
      />
    );
  };

  removeInvalidCharacters = (voucherId) => {
    if(!voucherId){
      return ''
    } else {
      const validString = voucherId.replace(/[^a-zA-Z0-9-]*$/g, '')
      return validString
    }

  }

  onClickConfirm = () => {
    const { isAuthed, selectedPlanIdx } = this.state;

    if (!isAuthed) {
      this.setState({
        authError: "Please log in or create an account",
      });
    } else {
      this.initRedeemVoucher();
    }
  };


  initRedeemVoucher = async () => {
    this.setState({ redeemLoading: true });

    const { userId, voucherId } = this.state;

    const payload = {
      voucherId,
      userId
    }

    const { success, error } = await this.props.actions.paymentActions.initRedeemVoucher(payload);

    if(success) {
      const { coachOrgId, customSuccessURL } = success
      if(customSuccessURL){
        window.location = customSuccessURL
      } else {
        window.location = `https://trybe.do/site_checkout_success?coachOrgId=${coachOrgId}`; //success val is Stripe Checkout seshion link
      }
    } else {
      const { message } = error
      this.setState({
        redeemLoading: false,
        redeemError: message,
      });
    }
  }

  renderConfirmButton = () => {
    const text = "Confirm";
    const confirmText = <div className="confirm-button-text">{text}</div>;
    const loader = <div className="loader" />;

    return (
      <button
        type="button"
        className="confirm-button"
        disabled={!this.state.isAuthed || !this.state.voucherId || this.state.redeemLoading}
        onClick={this.onClickConfirm}
      >
        {this.state.redeemLoading ? loader : confirmText}
      </button>
    );
  };

  renderRedeemError = () => {
    if(!this.state.redeemError) return null

    return (
      <div className='confirm-errors'>
        <div className='error-text'> {this.state.redeemError} </div>
      </div>
    );
  }

  render() {
    const { isAuthed, pwError, emailError, loginError, activeSection } =
      this.state;
    return (
      <div className="redeem-voucher-container">
        <div className="main-body">
          {/* <div>
            <div>Instructions</div>
            <div>
              To redeem voucher: Please first create or log in with an existing
              account. Then enter the voucher, note that the code is
              CASE-SENSITIVE.
            </div>
          </div> */}
          <div className={"section-container"}>
            <div
              className={
                activeSection === 0
                  ? "section-header-active"
                  : "section-header-inactive"
              }
            >
              <div className={isAuthed ? "section-checkmark" : null} />
              {"1. Create a Trybe account"}
            </div>
            <div
              className={
                activeSection === 0
                  ? "create-account-active"
                  : "create-account-inactive"
              }
            >
              {this.renderAccountSection()}
              {pwError || emailError || loginError ? this.renderErrors() : null}
            </div>
          </div>
          <div className={"section-container"}>
            <div
              className={
                activeSection === 1
                  ? "section-header-active"
                  : "section-header-inactive"
              }
            >
              <div className={isAuthed ? "section-checkmark" : null} />
              {"2. Enter Voucher Code"}
            </div>
            <div className={"voucher-container"}>
              {this.renderVoucherInput()}
              <div className="voucher-footnote">Dashes not required. Code is case-sensitive</div>
              {pwError || emailError || loginError ? this.renderErrors() : null}
            </div>
          </div>
          {this.renderConfirmButton()}
          {this.renderRedeemError()}
        </div>
        <div className="contact-us">
          Need further support? Contact us at{" "}
          <a className="link" href="mailto:support@trybe.do">
            support@trybe.do
          </a>
        </div>
      </div>
    );
  }
}

export default RedeemVoucher;



// WEBPACK FOOTER //
// ./src/components/payments/RedeemVoucher.js